<template>
    <div>
        <h1 v-if="!forDenomination">{{ $t('setup.status.header') }}</h1>
        <h1 v-if="forDenomination">{{ $t('setup.status.headerDenomination') }}</h1>
        <div class="ct-card">
            <section class="top-margin">
                <div v-if="showError" class="ct-text alert alert-danger" role="alert">
                    {{ errorMessage }}
                </div>
                <div v-if="!showError" class="ct-text">
                    {{ $t('setup.status.description') }}
                </div>
            </section>
            <section class="ct-action">
                <div class="progress" v-if="!showError">
                    <div
                        class="progress-bar progress-bar-success progress-bar-striped active"
                        role="progressbar"
                        :aria-valuenow="progressValue"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        :style="{ width: progressValue + '%' }"
                    >
                        <span class="sr-only">45% Complete</span>
                    </div>
                </div>
            </section>
        </div>
        <captera capteraKey="0e7f654b741c11525ae05c9c309c910b" vid="2110740"></captera>
    </div>
</template>
<script>
import Vue from 'vue';
import RegistrationClient from './RegistrationClient';
import Captera from '../components/Captera.vue';

export default {
    components: {
        Captera
    },
    data() {
        return {
            progressValue: 0,
            showError: false,
            errorMessage: 'FEHLER!'
        };
    },
    computed: {
        information: function() {
            return this.$store.getters['registrations/registerInformation'];
        },
        forDenomination() {
            return !!this.information.denomination;
        }
    },
    mounted() {
        if (typeof this.$route.params.token !== 'undefined' && this.$route.params.token !== '') {
            this.$store.dispatch('registrations/loadRegistration', { token: this.$route.params.token });
            this.updateSetupProgress();
        }
    },
    methods: {
        updateSetupProgress: function() {
            const validationToken = this.$route.params.token;
            const interval = setInterval(() => {
                this.incrementProgressValue();
                RegistrationClient.setupStatus(
                    validationToken,
                    setupStatus => {
                        this.changeProgressValue(setupStatus.progress);
                        if (setupStatus.progress < 0) {
                            this.showError = true;
                            this.errorMessage = this.$i18n.t('setup.status.error', { email: this.information.email });
                            clearInterval(interval);
                        } else if (setupStatus.progress === 60) {
                            clearInterval(interval);
                            if (hasFacebookPixel) {
                                fbq('track', 'Purchase');
                            }
                            this.$router.push({ name: 'SetupFinished', params: { token: this.$route.params.token } });
                        }
                    },
                    error => {
                        this.showError = true;
                        clearInterval(interval);
                        this.errorMessage = this.$i18n.t(error.response.data.messageKey);
                    }
                );
            }, 1000);
        },

        incrementProgressValue: function() {
            if (this.progressValue < 95 && this.progressValue >= 20) {
                this.progressValue += 1;
            }
        },

        changeProgressValue: function(workflowStatus) {
            if (workflowStatus === 0 && this.progressValue === 0) {
                this.progressValue = 0;
            } else if (workflowStatus === 10) {
                this.progressValue = 10;
            } else if (this.progressValue < 20 && workflowStatus === 20) {
                this.progressValue = 20;
            } else if (workflowStatus === 30) {
                this.progressValue = 95;
            } else if (workflowStatus === 40) {
                this.progressValue = 97;
            } else if (workflowStatus === 50) {
                this.progressValue = 99;
            } else if (workflowStatus === 60) {
                this.progressValue = 100;
            }
        }
    }
};
</script>
<style></style>
